import { CommunityLiveState } from './constants'

interface Town {
  liveState?: string
  childCommunities?: { nodes?: { liveState?: string }[] }
}

// A town is live when it or one of its child towns is live.
export const isCommunityLive = (community: void | null | Town): boolean =>
  community?.liveState === CommunityLiveState.LIVE || (community?.childCommunities?.nodes || []).some(c => c.liveState === CommunityLiveState.LIVE)

// A record's own town, wherever it is linked or labelled (CVL-153): the first town it was added to
// among its live towns, else the first town it was added to. The server's
// LinkableToCommunities#own_community is the same rule. `towns` comes in the order the record was
// added to them, as the API returns it.
export const recordTown = <T extends Town>(towns: void | null | T[]): T | undefined => towns?.find(isCommunityLive) || towns?.[0]
